<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5><i class="fa fa-fw fa-ticket mr-2" />Invoice</h5>
            <hr />
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="mr-2"
                            v-model="filter.no"
                            type="search"
                            id="filterInput"
                            placeholder="No. Invoice"
                            @keyup.enter="getItems"
                        />
                        <b-form-select class="mr-2" v-model="filter.status" :options="optStatus">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Status Invoice</b-form-select-option>
                                <b-form-select-option value="-1">Semua</b-form-select-option>
                            </template>
                        </b-form-select>
                        <multiselect v-model="filter.buyer"
                            class="mr-2"
                            :options="optBuyer"
                            :allow-empty="true"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Pembeli"
                        />
                        <b-form-input class="mr-2" v-model="filter.start" type="date" />
                        <b-form-group label="s.d." label-cols>
                            <b-form-input class="mr-2" v-model="filter.end" type="date" />
                        </b-form-group>
                    </div>
                </b-form-group>
            </div>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group class="form-inline form-group-wrapper mb-3">
                    <div class="d-flex search-input-wrapper">
                        <b-form-select class="mr-2" v-model="filter.sortBy" :options="optSortBy">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Sortir</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button variant="primary" @click="getItems">
                            <i class="fa fa-search" />
                        </b-button>
                    </div>
                </b-form-group>
                <div class="mb-3">
                    <b-button variant="dark" @click="openModalPiutang">
                        Daftar Piutang
                    </b-button>
                    <b-button variant="success" class="ml-2" @click="$bvModal.show('modal-excel-harian')">
                        <i class="fa fa-download mr-2" /> Excel Invoice Harian
                    </b-button>
                </div>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
                @row-dblclicked="onRowDoubleClick"
            >
                <template v-slot:empty>
                    Tidak ada order.
                </template>
                <template v-slot:cell(no)="row">
                    {{ row.item.no }}
                    <div class="small font-weight-bold">{{ $helper.parseDate(row.item.tanggal, true) }}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseStatus(row.item.status)">
                        {{ row.item.status }}
                    </b-badge>
                    <div v-if="row.item.status == 'PENDING'" class="small font-weight-bold">{{ $helper.parseDate(row.item.jatuhTempo, true) }}</div>
                </template>
                <template v-slot:cell(harga)="row">
                    Rp. {{ $helper.formatThousandSeparator(row.item.totalPembayaran) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail" @click="openDetailModal(row.item.id)">
                        <i class="fa fa-fw fa-search" />
                    </b-button>
                    <b-button v-if="row.item.status == 'PENDING'" class="ml-2" size="sm" variant="success" v-b-tooltip.hover.top title="Set Lunas" @click="openSetLunasModal(row.item)">
                        <i class="fa fa-fw fa-check" />
                    </b-button>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                    @change="onPageChange"
                />
            </div>
        </b-card>
        <b-modal id="modal-detail" title="Detail Order" size="lg"
            centered no-close-on-backdrop hide-footer
        >
            <b-spinner v-if="isLoadingDetail" />
            <div v-else>
                <b-row class="mb-3">
                    <b-col md="4">
                        No. Invoice
                        <div class="font-weight-bold">{{ detail.head.no }}</div>
                    </b-col>
                    <b-col md="4">
                        Nama Pembeli
                        <div class="font-weight-bold">{{ detail.head.pembeli }}</div>
                    </b-col>
                    <b-col md="4">
                        Tanggal Invoice
                        <div class="font-weight-bold">{{ $helper.parseDate(detail.head.tanggal, true) }}</div>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col md="4">
                        Status Invoice
                        <div class="font-weight-bold">{{ detail.head.status }} {{ detail.head.status == "PENDING" ? $helper.parseDate(detail.head.jatuhTempo, true) : "" }}</div>
                    </b-col>
                    <b-col md="4">
                        Jumlah Item
                        <div class="font-weight-bold">{{ detail.head.jumlahItem }}</div>
                    </b-col>
                    <b-col md="4">
                        Total Harga Pembelian
                        <div class="font-weight-bold">Rp. {{ $helper.formatThousandSeparator(detail.totalHargaPembelian) }}</div>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col md="4">
                        Persentase Diskon
                        <div class="font-weight-bold">{{ detail.diskonPersen }} %</div>
                    </b-col>
                    <b-col md="4">
                        Nominal Diskon
                        <div class="font-weight-bold">Rp. {{ $helper.formatThousandSeparator(detail.diskonNominal) }}</div>
                    </b-col>
                    <b-col md="4">
                        Total Pembayaran
                        <div class="font-weight-bold">Rp. {{ $helper.formatThousandSeparator(detail.head.totalPembayaran) }}</div>
                    </b-col>
                </b-row>
                <b-table bordered hover
                    :items="detail.details"
                    :fields="modalFields"
                    responsive
                >
                    <template v-slot:cell(name)="row">
                        <b>{{ row.item.model }}</b>
                        <div>{{ row.item.ukuran }} - {{ row.item.warna }}</div>
                    </template>
                    <template v-slot:cell(harga)="row">
                        Rp. {{ $helper.formatThousandSeparator(row.item.harga) }}
                    </template>
                    <template v-slot:cell(total)="row">
                        Rp. {{ $helper.formatThousandSeparator(row.item.total) }}
                    </template>
                </b-table>
            </div>
        </b-modal>
        <b-modal id="modal-set-lunas" title="Konfirmasi Set Lunas"
            centered no-close-on-backdrop hide-footer
        >
            <div>
                Konfirmasi pelunasan untuk Invoice No. <b>{{ activeItem.no }} ({{ activeItem.pembeli }})</b> sebesar Rp. {{ $helper.formatThousandSeparator(activeItem.totalPembayaran) }}?
            </div>
            <b-button variant="primary" class="mt-3" @click="executeSetLunas" :disabled="isSubmitting">
                {{ isSubmitting ? "Menyimpan..." : "Set Lunas" }}
            </b-button>
        </b-modal>
        <b-modal id="modal-piutang" title="Daftar Piutang Berjalan"
            centered no-close-on-backdrop hide-footer
        >
            <div v-if="isLoadingDetail">
                Mengambil data piutang, mohon menunggu...
            </div>
            <div v-else>
                Daftar Piutang Berjalan:
                <ul>
                    <li v-for="item in listPiutang" v-bind:key="item.name">
                        {{ item.pembeli }} - {{ item.jumlah }} invoice pending ( Rp. {{ $helper.formatThousandSeparator(item.piutang) }} )
                    </li>
                </ul>
                <div class="mt-3">
                    Total Piutang Berjalan: <strong>Rp. {{ $helper.formatThousandSeparator(listPiutang.reduce((total, item) => total + item.piutang, 0)) }} </strong>
                </div>
            </div>
        </b-modal>
        <b-modal id="modal-excel-harian" title="Download Excel Invoice Harian"
            centered no-close-on-backdrop hide-footer @hidden="printStatus = 0"
        >
            <div v-if="printStatus == 0">
                <b-input-group>
                    <b-form-input type="date" v-model="tanggalInputExcel" />
                    <b-input-group-append>
                        <b-button variant="success" @click="executeDownloadInvoiceHarian">Download Invoice</b-button>
                    </b-input-group-append>
                </b-input-group>
            </div>
            <div v-else-if="printStatus == 1">
                Menyiapkan excel, mohon menunggu...
            </div>
            <div v-else-if="printStatus == 2">
                <div class="mb-3">Excel siap didownload.</div>
                <a :href="excelPath" download>
                    <b-button variant="success">
                        <i class="fa fa-download" /> Download
                    </b-button>
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'invoice-list',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isLoadingDetail: false,
            isSubmitting: false,
            show: 10,

            printStatus: 0,
            tanggalInputExcel: "",
            excelPath: "",

            input: {
                name: "",
                photo: null,
                kategori: null
            },

            edit: {
                name: "",
                photo: null,
                kategori: null
            },

            filter: {
                no: "",
                sortBy: 1,
                status: -1,
                buyer: null,
                start: null,
                end: null
            },

            detail: {
                head: { },
                totalHargaPembelian: 0,
                diskonPersen: 0.0,
                diskonNominal: 0,
                details: []
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "no", label: "No. Invoice" },
                { key: "pembeli", label: "Pembeli" },
                { key: "status", label: "Status" },
                { key: "jumlahItem", label: "Jumlah Item" },
                { key: "harga", label: "Total Pembayaran" },
                { key: "action", label: "Aksi" },
            ],

            modalFields: [
                { key: "name", label: "Nama Produk" },
                { key: "sku", label: "SKU" },
                { key: "jumlah", label: "Jumlah" },
                { key: "harga", label: "Harga Satuan" },
                { key: "total", label: "Harga Total" }
            ],

            items: [],
            activeItem: {},
            listPiutang: [],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optBuyer: [],
            optStatus: [
                { text: "Pending", value: 0 },
                { text: "Lunas", value: 1 },
            ],

            optSortBy: [
                { text: "Tanggal Invoice Terbaru -> Terlama", value: 1 },
                { text: "Tanggal Invoice Terlama -> Terbaru", value: 2 },
                { text: "Jatuh Tempo Terdekat", value: 3 },
                { text: "Jatuh Tempo Terjauh", value: 4 },
            ]

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getBuyerOpt = this.$axios.get("user/buyer").then(res => {
                this.optBuyer = res.data
            })

            Promise.all([getItems, getBuyerOpt]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += "&sortBy=" + this.filter.sortBy

            if(!this.$helper.isBlank(this.filter.no)) {
                param += "&filterNo=" + this.filter.no
            }

            if(!this.$helper.isBlank(this.filter.start)) {
                param += "&filterStart=" + this.filter.start
            }

            if(!this.$helper.isBlank(this.filter.end)) {
                param += "&filterEnd=" + this.filter.end
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(this.filter.buyer != null) {
                param += "&filterUserId=" + this.filter.buyer.id
            }

            // Execute
            return this.$axios.get("invoice/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        openDetailModal(id) {

            this.isLoadingDetail = true
            this.$bvModal.show("modal-detail")

            this.$axios.get("invoice/" + id).then(res => {
                this.detail = res.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadingDetail = false
            })

        },

        openSetLunasModal(item) {
            this.activeItem = item
            this.$bvModal.show("modal-set-lunas")
        },

        executeSetLunas() {

            this.isSubmitting = true
            let payload = new FormData()
            payload.append("invoiceId", this.activeItem.id)

            this.$axios.post("invoice/set-lunas", payload).then(res => {

                this.$helper.toastSuccess(this, "Invoice berhasil set lunas!")
                this.$bvModal.hide("modal-set-lunas")
                this.getItems()

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },

        openModalPiutang() {

            this.isLoadingDetail = true
            this.$bvModal.show("modal-piutang")

            this.$axios.get("invoice/piutang-semua").then(res => {
                this.listPiutang = res.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadingDetail = false
            })

        },

        executeDownloadInvoiceHarian() {

            this.printStatus = 1
            this.$axios.get("invoice/excel?tanggal=" + this.tanggalInputExcel).then(res => {

                this.printStatus = 2
                this.excelPath = this.$BASE_FILE_PATH + res.data.name

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.printStatus = 0
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        onRowDoubleClick(item) {
            this.openDetailModal(item.id)
        },

        parseStatus(status) {
            switch(status) {
                case "PENDING": return "warning"
                case "LUNAS": return "success"
                default: return "light"
            }
        }

    },

    created() {
        this.init()
    }

}
</script>
